exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager .others-container{padding:20px;min-width:500px}#doc-manager .others-container form{max-width:40%}#doc-manager .others-container .question-icon{font-size:14px}#doc-manager .others-container .custom-control-label{font-size:12px;padding-top:5px}#doc-manager .others-container .is-invalid.remove-warning{background-image:inherit}", ""]);

// exports
